import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { User } from 'shared-stuff';
import { AuthService } from 'app/core/auth.service';

@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './app-sidebar-nav.component.html'
})
export class AppSidebarNavComponent {

  // navigation is how the sidebar gets built
  // must be in this file since it references this.auth
  public navigation = [
    // {
    //   title: true,
    //   name: 'Apprentice Application',
    //   applicant: true,
    // },
    {
      name: 'Choose a program',
      url: `/user/${this.auth.uid}/choose`,
      icon: 'fa fa-hand-pointer-o',
      applicant: true,
    },
    {
      name: 'View progress',
      url: `/user/${this.auth.uid}/progress`,
      icon: 'icon-speedometer',
      applicant: true,
    },
    {
      name: 'Basic info',
      url: `/user/${this.auth.uid}/basic`,
      icon: 'icon-note',
      applicant: true,
    },
    {
      name: 'Drivers License',
      url: `/upload/${this.auth.uid}/license`,
      icon: 'fa fa-drivers-license-o fa-lg',
      applicant: true,
    },
    {
      name: 'Education',
      url: `/upload/${this.auth.uid}/education`,
      icon: 'icon-graduation',
      applicant: true,
    },
    {
      name: 'Demographics',
      url: `/user/${this.auth.uid}/demographics`,
      icon: 'icon-envelope-letter',
      applicant: true,
    },
    {
      name: 'Algebra Requirements',
      url: `/upload/${this.auth.uid}/algebra`,
      icon: 'icon-calculator',
      applicant: true,
      algebra: true,
    },
    {
      name: 'Testing Requirements',
      url: `/upload/${this.auth.uid}/testing`,
      icon: 'fa fa-check-square-o',
      applicant: true,
      testing: true,
    },
    {
      name: 'Information Verification',
      url: `/user/${this.auth.uid}/verify`,
      icon: 'fa fa-gavel',
      applicant: true,
    },
    {
      title: true,
      name: 'Admin tools',
      admin: true,
    },
    {
      name: 'Active Users',
      url: '/admin/users',
      icon: 'icon-people',
      admin: true,
    },
    {
      name: 'Actions Required',
      url: '/admin/required',
      icon: 'icon-badge',
      admin: true,
    },
    {
      name: 'Archived Users',
      url: '/admin/archive',
      icon: 'icon-lock',
      admin: true,
    },

    {
      name: 'Admins',
      url: '/admin/admins',
      icon: 'fa fa-user-circle',
      admin: true,
    },
  ];

  public displayTitle(navItem: any, user: User): boolean {
    if (!navItem.title) return false // not a title

    return this.navLogic(navItem, user)
  }

  public displayNavItem(navItem: any, user: User): boolean {
    if (navItem.title) return false // title items not allowed

    return this.navLogic(navItem, user)
  }

  private navLogic(navItem: any, user: User): boolean {
    // determine if a user should see this particular navbar item
    // all the following conditions would mean they are disqualified from seeing a particular item

    // null checking 
    if (!navItem) return false;
    if (!user) return false;
    // admin only items
    if (navItem.admin && !user.admin) return false
    // applicant only items
    if (navItem.applicant && user.admin) return false
    // programs that have algrebra requirement
    if (navItem.algebra && user.pick1 !== 'electrical' && user.pick1 !== 'steam') return false
    // programs that have testing requirements
    if (navItem.testing && user.pick1 !== 'electrical' && user.pick1 !== 'steam' && user.pick1 !== 'construction' && user.pick1 !== 'carpentry' && user.pick1 !== 'hfi' && user.pick1 !== 'sprinkler' && user.pick1 !== 'hvac' && user.pick1 !== 'plumbing' && user.pick1 !== 'sheet') return false

    // if the user made it through the gauntlet of disqualifying checks then the nav-item will be displayed
    return true;
  }

  public noAdmin(item) {
    return item.admin ? false : true
  }

  public isTitle(item) {
    return item.title ? true : false
  }

  constructor(
    private auth: AuthService
  ) { }
}

import { Router } from '@angular/router';


@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
      <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }

  constructor(private router: Router) { }

}

@Component({
  selector: 'app-sidebar-nav-link',
  template: `
    <a *ngIf="!isExternalLink(); else external"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      [routerLink]="[link.url]"
      (click)="hideMobile()">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ng-template #external>
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
    </ng-template>
  `
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  public hideMobile() {
    if (document.body.classList.contains('sidebar-mobile-show')) {
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }

  constructor() { }
}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor() { }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if (this.title.class) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if (this.title.wrapper) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts